import { Assignment } from './assignment';

export class Position {
  id: number;
  name: string;
  start: string;
  end: string;
  assignments: Assignment[] = [];
  status = 0;
  isOverflow = 0;
  hoverText = '';
  isMulti = 0;
  isSplitMulti = 0;
  requirement = 0;
  workArea = '';
  isRequested = 0;
  dataLoaded = 0;
  isConfirmed = false;
  isStartTimeEdit = false;
  isEndTimeEdit = false;
  startHours = '';
  startMinutes = '';
  endHours = '';
  endMinutes = '';
  loading = false;
}
